import { actionTypes } from "../utils";

export const types = {
  ...actionTypes('SET_OBLIGATIONS'),
  ...actionTypes('SET_MESSAGES'),
  ...actionTypes('ADD_MESSAGE'),
  ...actionTypes('UPDATE_OBLIGATION'), 
  ...actionTypes('UPDATE_OBLIGATION_MOTHER'),
  ...actionTypes('CREATE_OBLIGATION'),
  ...actionTypes('DELETE_OBLIGATION'),
  ...actionTypes('DELETE_OBLIGATION_ALL_CLONES'),
  ...actionTypes('RESET_OBLIGATIONS'),
  ...actionTypes('ASSIGN_USER'),
  ...actionTypes('MASS_ASSIGN_OBLIGATIONS'),
  ...actionTypes('SET_OBLIGATIONS_COUNTERS'),
  ...actionTypes('CHECK_OBLIGATION'),
};